import {
  AbstractControl,
  FormGroup,
  ValidatorFn,
  Validators,
} from '@angular/forms';
export const tidPasswordValidations = [
  Validators.required,
  Validators.minLength(8),
  Validators.maxLength(20),
  Validators.pattern(/[a-z]/), // has lower
  Validators.pattern(/[A-Z]/), // has upper
  Validators.pattern(/\d/), // has number
  Validators.pattern(/[!@#$%&*^_\-+]/), // allowed special chars, see: SWMI-1030
];

export const alkLoginPasswordValidations = [
  Validators.required,
  Validators.minLength(8),
  Validators.maxLength(20),
];

export const phoneNumberValidations = [
  Validators.required,
  Validators.maxLength(20),
  Validators.pattern(
    /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im
  ),
];

export const emailValidations = [Validators.required, Validators.email];

export const emailPattern =
  /^\w+([.-]?\w+)*@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,24}|[0-9]{1,3})(\]?)$/;
export const emailPatternWithPlus =
  /^\w+([.+-]?\w+)*@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,24}|[0-9]{1,3})(\]?)$/;

// eslint-disable-next-line no-useless-escape
export const REGEX_LON = new RegExp(
  /^-?([0-9]{1,2}|1[0-7][0-9]|180)(\.[0-9]{1,10})?$/gi
);
export const REGEX_LAT = new RegExp(/^-?([0-8]?[0-9]|90)(\.[0-9]{1,10})$/gi);
export const INVALID_CHAR_REGEX = new RegExp(/^[^^/\\]+$/);

export const cardValidations = [
  Validators.required,
  Validators.minLength(15),
  Validators.maxLength(19),
];

export const cvvValidations = [
  Validators.required,
  Validators.minLength(3),
  Validators.maxLength(3),
];
export function validLatLon(value, maxBound) {
  if (isNaN(value) || Number(value) < -maxBound || Number(value) > maxBound) {
    return false;
  }
  return true;
}

export const validateLatitude = (control: AbstractControl) => {
  return !validLatLon(control.value, 90) ? { invalidLat: true } : null;
};
export const validateLongitude = (control: AbstractControl) => {
  return !validLatLon(control.value, 180) ? { invalidLat: true } : null;
};

export const validateLatLon = (control: AbstractControl) => {
  if (control.value && isNaN(control.value)) {
    const pieces = control.value.split(',');
    if (pieces.length < 2) {
      return null;
    }
    if (!validLatLon(pieces[0], 90) || !validLatLon(pieces[1], 180)) {
      return { invalidLat: true };
    }
    return null;
  }
};
export const validateName = (control: AbstractControl) => {
  if (control.value) {
    if (!INVALID_CHAR_REGEX.test(control.value)) {
      return { invalidName: true };
    }
    return null;
  }
};
export function emailLengthValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    if (control.value && isNaN(control.value)) {
      if (control.value.includes('@')) {
        const result = control.value.split('@');
        if (result[0].length > 64 || result[1].length > 256) {
          return { maxLength: true };
        }
      }
    }
    return null;
  };
}

export function MustMatch(controlName: string, matchingControlName: string) {
  return (formGroup: FormGroup) => {
    const control = formGroup.controls[controlName];
    const matchingControl = formGroup.controls[matchingControlName];
    if (matchingControl.errors && !matchingControl.errors.mustMatch) {
      return;
    }
    if (control.value !== matchingControl.value) {
      matchingControl.setErrors({ mustMatch: true });
    } else {
      matchingControl.setErrors(null);
    }
  };
}
